let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '充电桩型号名称',
        props: 'pileTypeName',
        minWidth: 200,
    },
    {
        label: '型号',
        props: 'pileTypeCode',
        minWidth: 300,
        tooltip:true,
    },
    {
        label: '类型',
        props: 'pileTypeNo',
        minWidth: 200,
    },
    {
        label: '接口类型',
        props: 'interfaceTypeName',
        minWidth: 200,
    },
    {
        label: '充电枪数量',
        props: 'gunNum',
        minWidth: 200,
    },
    {
        label: '系统状态',
        props: 'useStateName',
        minWidth: 120,
    },
    {
        label: '编辑人',
        props: 'lastModifiedByName',
        minWidth: 200,
    },
    {
        label: '编辑时间',
        props: 'lastModifiedWhen',
        minWidth: 180,
    },
];

// // 面包屑
pageConfig.listBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'title',
    name: '充电管理'
},
{
    type: 'title',
    name: '充电桩型号管理'
}];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: true,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}
// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'pileModelDetail',
};

// 路由
pageConfig.listRouter = 'pileModelList';

// 详情的面包屑
pageConfig.detailBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'title',
    name: '充电管理',
},
{
    type: 'router',
    name: '充电桩型号管理',
    router: 'pileModelList'
},
{
    type: 'title',
    name: '充电桩型号详情',
},
];

pageConfig.formRules = {
    pileTypeName: [{
        required: true,
        message: '请填写充电桩型号名称',
        trigger: 'blur'
    }],
    pileTypeCode: [{
        required: true,
        message: '请填写型号',
        trigger: 'blur'
    }],
    currentOutType: [{
        required: true,
        message: '请选择电流输出类型',
        trigger: 'change'
    }],
    chargingSpeed: [{
        required: true,
        message: '请选择充电速度',
        trigger: 'change'
    }],
    interfaceType: [{
        required: true,
        message: '请选择接口类型',
        trigger: 'change'
    }],
    gunNum: [{
        required: true,
        message: '请填充电枪数量',
        trigger: 'blur'
    }],
    useState: [{
        required: true,
        message: '请选择系统状态',
        trigger: 'change'
    }],
    ratedPower: [
        {
            required: true,
            message: '请输入额定功率',
            trigger: 'blur'
        },
        {
            required: true,
            pattern: /^(([1-9]\d*|0)(|\.\d{1,2}))$/,
            message: '请输入数字，且最多保留小数点后两位',
            trigger: 'blur'
        }
    ],
};



export default pageConfig;